/** Shopify CDN: Minification failed

Line 57:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 58:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 62:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 68:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 85:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 86:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 94:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 106:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 126:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 126:37 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 43:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 44:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 48:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 54:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 71:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 72:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 80:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 92:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 112:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 112:37 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 29:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 30:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 34:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 40:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 57:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 58:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 66:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 78:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 98:37 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
/** Shopify CDN: Minification failed

Line 15:0 Transforming class syntax to the configured target environment ("es5") is not supported yet
Line 16:13 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 20:19 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 26:20 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 43:6 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 44:4 Transforming const to the configured target environment ("es5") is not supported yet
Line 52:16 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 64:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:21 Transforming object literal extensions to the configured target environment ("es5") is not supported yet
Line 84:37 Transforming default arguments to the configured target environment ("es5") is not supported yet

**/
class MiniCart extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.header = document.querySelector('sticky-header');
    this.drawer = document.querySelector('cart-drawer');
    new IntersectionObserver(this.handleIntersection.bind(this)).observe(this);
  }

  handleIntersection(entries, observer) {
    if (!entries[0].isIntersecting) return;
    observer.unobserve(this);

    fetch(this.dataset.url)
      .then(response => response.text())
      .then(html => {
        document.getElementById('mini-cart').innerHTML =
          this.getSectionInnerHTML(html, '.shopify-section');
          
          document.dispatchEvent(new CustomEvent('cartdrawer:opened'));
      })
      .catch(e => {
        console.error(e);
      });
  }

  open() {
    const detailsElement = this.drawer.querySelector('details');
    if (detailsElement.hasAttribute('open')) {
      return;
    }
    
    this.drawer.openMenuDrawer();
  }

  renderContents(parsedState) {
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      if (document.getElementById(section.id)) {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }
    }));

    this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'mini-cart',
        section: 'mini-cart',
        selector: '.shopify-section'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'mobile-cart-icon-bubble',
        section: 'mobile-cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
}

customElements.define('mini-cart', MiniCart);
